import Loader from "@/utility/loader";
import {$t} from "@/i18n";


export default class Model {

    constructor(importSessionId) {
        this.file = null
        this.staticFields = []
        this.mappedFields = []
        this.importFields = []
        this.previewData = []
        this.firstRowIsHeader = true
        this.companyId = null
        this.loader = new Loader()
        this.importSessionId = importSessionId
        this.showAddCustomFieldDialog = false
    }

    setImportFields(value) {
        this.importFields = value
    }

    getImportFields() {
        return this.importFields
    }

    getLoader() {
        return this.loader
    }

    setFile(value) {
        this.file = value
    }

    getFile() {
        return this.file
    }

    setFirstRowIsHeader(value) {
        this.firstRowIsHeader = value
    }

    getFirstRowIsHeader() {
        return this.firstRowIsHeader
    }

    getAvailableFields() {
        let arr = [];
        let selected_fields = []
        selected_fields = selected_fields.concat(this.staticFields.map(x => x.uku_key))
        selected_fields = selected_fields.concat(this.mappedFields.map(x => x.uku_key))

        for (let field of this.getImportFields()) {
            if (!selected_fields.find(x => x === field.uku_key)) {
                arr.push(field);
            }
        }

        arr.sort(function (a, b) {
            if (a.title < b.title) return -1;
            if (a.title > b.title) return 1;
            return 0;
        });

        return arr;
    }

    getAvailableFieldParsers() {
        const staticFields = this.getStaticFields().map(f => f.uku_key)

        let arr = this.getImportFields().reduce((result_arr, importField) => {
            let uku_key = importField.uku_key

            if (staticFields.indexOf(uku_key) === -1) {
                let title = importField.title
                if (uku_key.indexOf('contact') !== -1) {
                    title += ' - ' + $t('Contact');
                }
                const dataField = {
                    title: title,
                    uku_key: uku_key,
                }
                return [...result_arr, dataField]
            }
            return result_arr
        }, [])

        arr.sort(function (a, b) {
            if (a.title < b.title) return -1;
            if (a.title > b.title) return 1;
            return 0;
        });
        return arr;
    }

    removeStaticField(uku_key) {
        this.staticFields = this.staticFields.filter(x => x.uku_key !== uku_key)
    }

    addStaticField(field) {
        let field_data = {...field}
        field_data.value = null;
        field_data.value_f = "";
        field_data.value_error = null;

        this.staticFields.push(field_data);
    }

    getStaticFields() {
        return this.staticFields
    }

    setCompanyId(value) {
        this.companyId = value
    }

    getCompanyId() {
        return this.companyId
    }

    getImportFromRow() {
        return this.firstRowIsHeader ? 1 : 0
    }

    setMappedFields(value) {
        this.mappedFields = value
    }

    getMappedFields() {
        return this.mappedFields
    }

    getSaveDataMappedFields() {
        let mappedFields = this.mappedFields.slice()
        let regCode = mappedFields.find(x => x.uku_key === 'client.reg_code')
        if (regCode) {
            mappedFields.push({
                column: regCode.column,
                uku_key: "import_client_id",
            })
        }

        return mappedFields
    }

    setPreviewData(value) {
        this.previewData = value
    }

    getPreviewData() {
        let previewDataCopy = JSON.parse(JSON.stringify(this.previewData))
        const columnCount = previewDataCopy.length ? previewDataCopy[0].length : 0

        previewDataCopy = previewDataCopy.map((row, index) => {
            row.unshift(index + 1)
            return row
        })

        const headerRowTitles = ['']
        for (let i = 0; i < columnCount; i++) {
            headerRowTitles.push(this.indexToHeaderChar(i))
        }
        previewDataCopy.unshift(headerRowTitles)

        return previewDataCopy
    }

    getImportSessionId() {
        return this.importSessionId
    }

    getExcelSaveData() {
        return {
            account_id: this.getCompanyId(),
            data_object: "client",
            file_type: "xlsx",
            id: this.getImportSessionId(),
            settings: {
                static_fields: this.getStaticFields(),
                mapped_fields: this.getSaveDataMappedFields(),
                extra_settings: {},
                import_from_row: this.getImportFromRow() ? 1 : 0
            },
            status: "verified"
        }
    }

    indexToHeaderChar(index) {
        const charMap = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
        let output = ''

        let firstPartIndex = Math.floor(index / charMap.length)
        if (firstPartIndex > 0) {
            output += charMap[firstPartIndex - 1]
        }

        let secondPartIndex = index % charMap.length
        output += charMap[secondPartIndex]

        return output
    }

    getHeaders() {
        if (this.getPreviewData().length === 0) return [{text: "", column: ""}];

        let headers = [];
        headers.push({text: "", column: ""});

        for (let i = 0; i < this.getPreviewData()[0].length - 1; i++) {
            let found = false;
            for (let mappedField of this.getMappedFields()) {
                if (mappedField.column === this.indexToHeaderChar(i)) {

                    headers.push({
                        text: this.indexToHeaderChar(i),
                        column: this.indexToHeaderChar(i),
                        uku_key: mappedField.uku_key,
                    });
                    found = true;
                    break;
                }
            }
            if (!found)
                headers.push({
                    text: this.indexToHeaderChar(i),
                    column: this.indexToHeaderChar(i),
                    uku_key: null,
                });
        }

        return headers;
    }

    setShowAddCustomFieldDialog(value) {
        this.showAddCustomFieldDialog = value
    }

    isAddCustomFieldDialogVisible() {
        return this.showAddCustomFieldDialog
    }

    mapped_column_changed(column, uku_key) {
        if (uku_key) {
            // console.log('mapped_column_changed :: column = ' + column + ' :: uku_key = "' + uku_key)
            this.removeStaticField(uku_key)

            let mappedFields = this.getMappedFields()
            mappedFields = mappedFields.filter(x => x.column !== column)
            this.setMappedFields(mappedFields)

            let newMappedField = null;
            for (let mappedField of this.getMappedFields()) {
                if (mappedField.column === column && mappedField.uku_key === uku_key) {
                    newMappedField = mappedField
                }
            }
            if (newMappedField === null) {
                newMappedField = {
                    uku_key: uku_key,
                    column: column,
                };
                // console.log('mapped_column_changed :: field_data', newMappedField)
                this.getMappedFields().push(newMappedField)
            }

        } else {
            // reset ?
            let mappedFields = this.getMappedFields()
            mappedFields = mappedFields.filter(x => x.column !== column)
            this.setMappedFields(mappedFields)
        }
    };

    getHeaderRow() {
        return this.getPreviewData()[1]
    }

    setMappedFieldsFromRowHeader() {
        const headerRowTitles = this.getHeaderRow()
        const importFields = this.getImportFields()
        const usedFieldNames = []

        // console.log('this.getAvailableFieldParsers()', this.getAvailableFieldParsers())
        // console.log('headerRowTitles', headerRowTitles)

        let idx = 0
        for (let headerTitle of headerRowTitles) {
            if (!headerTitle || headerTitle === 1) continue

            // console.log('')
            let _title = (headerTitle.value ? headerTitle.value : headerTitle).toString().trim().toLowerCase().split(':')[0]
            // console.info('headerTitle => ' + _title + ' :: headerTitle => ' + headerTitle)

            const importField = importFields.find(x => _title === x.title.trim().toLowerCase())
            if (importField) {
                // console.warn('importField', importField)
                let uku_key = importField.uku_key
                let fieldParser = this.getAvailableFieldParsers().find(x => x.uku_key === uku_key)
                if (fieldParser) {
                    // console.log('MATCHED :: ' + headerTitle + ' == "' + uku_key, fieldParser)
                    if (!usedFieldNames.includes(uku_key)) {
                        usedFieldNames.push(uku_key)
                        const headerObj = this.getHeaders().find(x => x.column === this.indexToHeaderChar(idx))
                        this.mapped_column_changed(headerObj.column, uku_key)
                    }
                } else {
                    console.error(headerTitle + ' == "' + uku_key)
                }
            }
            idx++
        }
        // console.log('usedFieldNames', usedFieldNames)
    }
}